import React from 'react'
import { withTranslation } from 'react-i18next'
import { SignatureRequestModuleView } from '../../views'
import { LocalStorageService, SignatureProfileService, UserSignatureProfileService } from '../../../services/index'
import { withRouter } from 'react-router'

class SignatureRequestModuleAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      userProfiles: [],
      title: props.t('signatureRequestModuleAction.title'),
      imgBackCard: '',
      signatureProfileSelect: {}
    }
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  signatureProfileService = new SignatureProfileService(this.url);
  userSignatureProfileService = new UserSignatureProfileService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");

    //All signature profiles from user
    let userProfiles =
      await this.userSignatureProfileService.getUserSignatureProfiles(
        this.token,
        user.userMetaData.userMifirma.id
      );

    //Add properties to card
    userProfiles.data = userProfiles.data.map((profile) => {
      if (userProfiles.data) {
        profile.title = profile.signatureProfile.name.slice(0, 42)
        profile.text = profile.signatureProfile.description.slice(0, 78)
        profile.img = profile.signatureProfile.icon;
        profile.imgBackCard = profile.signatureProfile.backgroundIcon;
        profile.url = (profile.signatureProfileId === 2) ? "/sign-request-by-volume" :
          {
            pathname: `/signature-request-profile/${profile.signatureProfileId}`,
            params: { dataItem: profile }
          }
      }
      return profile;
    });
    this.setState({
      userProfiles: userProfiles.data,
      loading: false,
    });
  }

  render() {
    return <SignatureRequestModuleView {...this.state} />;
  }
}

export default withRouter(withTranslation()(SignatureRequestModuleAction));
